export const parse_object_in_list_of_str = (data : string[]) => {
    if (!data) {
      return null
    }
  
    let results : Record<string, unknown>[] = [];
    data.forEach((item : string) => {
      let item_as_obj : Record<string, unknown> = JSON.parse(item);
      results.push(item_as_obj);
    });
    return results;
}


export const gender_mapping = (key : 0 | 1 | 2) => {
    let mapping = {
      0: "All",
      1: "Male",
      2: "Female"
    }
    return mapping[key];
}

export const add_comma = (number : number) => {
  if (number == null) {
    return ""
  }
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
